import axios, { InternalAxiosRequestConfig } from "axios";

// Base axios instance with baseURL configured
const baseAxios = axios.create({
  baseURL: "/",
});

// Axios instance with authentication token interceptor
export const tokenAxios = () => {
  const instance = axios.create({
    baseURL: "/",
  });

  instance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  });

  return instance;
};

export default baseAxios;
